import React from 'react';
import { Modal } from 'react-bootstrap';
import PortletBody from '../../../app/components/portlet/PortletBody';
import StyledButton from '../../../app/components/styledComponents/StyledButton';

const ShowRejectedReasonModal = ({ rejectReason, onHide }) => {
  return (
    <Modal show={rejectReason} centered onHide={onHide} size={'lg'}>
      <Modal.Header
        title="Order Rejection Reason"
        closeButton
        className="border-bottom-0 align-items-baseline"
      >
        <Modal.Title
          as="h4"
          className="flex-grow-1 p-2 cursor-pointer flex-center"
        >
          Order Rejection Reason
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex  flex-column bg-body rounded">
        <PortletBody className="p-3 p-md-4 w-100">
          <h6>{rejectReason}</h6>
        </PortletBody>
        <div className="d-flex justify-content-end mt-3">
          <div className="d-flex gap-3">
            <StyledButton
              variant={'white'}
              className="mb-2 border-0 fw-bold"
              onClick={onHide}
            >
              Close
            </StyledButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShowRejectedReasonModal;
